
import { useState } from 'react';
import { resourceFAQs } from '../../../mocks/resources';

export default function ResourcesFAQ() {
  const [openId, setOpenId] = useState<string | null>('1');

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-rose-100 rounded-full mb-6">
            <i className="ri-question-answer-line text-rose-600" />
            <span className="text-rose-700 text-sm font-medium">Got Questions?</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6">
            Frequently Asked <span className="text-rose-500">Questions</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Find quick answers to common questions about MtaPlannerPro and our resources.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-4">
          {resourceFAQs.map((faq, index) => (
            <div
              key={faq.id}
              className={`border rounded-2xl overflow-hidden transition-all duration-300 ${
                openId === faq.id
                  ? 'border-rose-200 bg-rose-50/50 shadow-lg shadow-rose-100'
                  : 'border-slate-200 bg-white hover:border-rose-200'
              }`}
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <div className="flex items-center gap-4">
                  <span className="w-8 h-8 bg-rose-100 text-rose-600 rounded-lg flex items-center justify-center text-sm font-semibold flex-shrink-0">
                    {index + 1}
                  </span>
                  <h3 className={`font-semibold pr-4 ${openId === faq.id ? 'text-rose-700' : 'text-slate-900'}`}>
                    {faq.question}
                  </h3>
                </div>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openId === faq.id ? 'bg-rose-500 text-white rotate-180' : 'bg-slate-100 text-slate-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-xl" />
                </div>
              </button>
              
              <div className={`overflow-hidden transition-all duration-300 ${
                openId === faq.id ? 'max-h-96' : 'max-h-0'
              }`}>
                <div className="px-6 pb-6 pl-18">
                  <div className="pl-12 text-slate-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 text-center">
          <p className="text-slate-600 mb-4">Still have questions?</p>
          <a
            href="/#contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-rose-500 text-white rounded-full font-semibold hover:bg-rose-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line" />
            <span>Contact Support</span>
          </a>
        </div>
      </div>
    </section>
  );
}
